import { useQueryClient } from 'react-query';

export const useInvalidateFaxTemplatesList = () => {
  const queryClient = useQueryClient();
  return () => {
    // invalidating until new websocket is complete
    const keys = ['list-infinite-coversheet-template'];
    queryClient.invalidateQueries(keys);
  };
};
